import jwt from "jwt-decode";
import moment from "moment";

export const isURLContainString = (url, strings) => {
  let isValid = false;

  strings.forEach((string) => {
    if (url.indexOf(string) > -1) {
      isValid = true;
    }
  });

  return isValid;
};

export const getTablePageBaseOnPageNumber = (
  pageNumber,
  pageSize,
  listLength
) => {
  if (pageNumber === "last") {
    return listLength / pageSize;
  } else if (pageNumber) {
    return parseInt(pageNumber) - 1;
  }

  return 0;
};

export const getTablePageBaseOnControlNumber = ({
  controlNr,
  pageSize,
  list,
}) => {
  const index = list.findIndex((row) => row.number === controlNr);

  if (index > 0) {
    return Math.floor(index / pageSize);
  }

  return 0;
};

// return false for null, undefined, '', 0, false, NaN. Otherwise return true

export const isTruthyValue = (...values) => {
  return values.some((value) => !!value);
};

// moved from CreateControl.js

export const addHours = (date, h) => {
  let newDate = new Date(date);
  newDate.setHours(newDate.getHours() + h);
  return newDate;
};

// moved from CreateControl.js

export const addDays = (date, days) => {
  let newDate = new Date(date);
  newDate.setDate(newDate.getDate() + days);
  return newDate;
};

// moved from CreateControl.js

export const handleDatePickedFrom = (e) => {
  let dateFrom = "";
  let dateTo = "";
  if (e !== null) {
    let date = new Date(e);
    dateFrom = addHours(date, 2);
    dateTo = addDays(dateFrom, 14);
  }

  return {
    dateFrom,
    dateTo,
  };
};

// moved from CreateControl.js

export const handleDatePickedTo = (e) => {
  let dateTo = "";
  if (e !== null) {
    let date = new Date(e);
    dateTo = addHours(date, 2);
  }

  return dateTo;
};

export const getPostControlDocType = (postControlDoc) => {
  const INF = postControlDoc.find((el) => el.postControlInfo);
  if (INF) {
    return "INF";
  }
  const NOTE = postControlDoc.find((el) => el.postControlNote);
  if (NOTE) {
    return "NOT";
  }

  return false;
};

export const isUserLoggedIn = () => {
  return (
    Boolean(localStorage.getItem("token")) &&
    Boolean(localStorage.getItem("is_logged"))
  );
};

export const removeSSOCookies = () => {
  localStorage.removeItem("token")
  localStorage.removeItem("is_logged")
};

export const getUserRole = (userData) => userData.user?.roleDetails?.role;

// pierwszy probram z program descriptor
export const getUserProgramFromPwd = (userData) => {
  let program = userData.user.roleDetails?.programDescriptors?.slice(0, 1).map(it => it.program)[0] || "";
  console.log("User program from pwds " + program);
  return program
};

export const setTokenExpireTime = (token) => {
  const tokenExpire = jwt(token).exp;

  const expireTime = moment.unix(tokenExpire);
  localStorage.setItem("userTime", expireTime.format());
};

export const getRemainingTokenTime = (expireTime) => {
  return moment.utc(moment(expireTime).diff(moment())).format("mm:ss");
};

export const getRemainingTokenTimeInSec = (expireTime) => {
  return moment(expireTime).diff(moment()) / 1000;
};

export const getRemainingTokenTimeInSecForRefreshToken = (expireTime) => {
	return moment(expireTime).diff(moment()) / 1000;
};

export const isTokenExpired = () => {
  const token = localStorage.getItem("token");

  if(token) {
    const tokenExpire = jwt(token).exp;

    const expireTime = moment.unix(tokenExpire);
    
    const alreadyExpired = moment().isAfter(expireTime);
    return alreadyExpired;
  }
}

export const compareByCode = (a, b) => {
  const splitedA = a.code.split('.');
  const splitedB = b.code.split('.');
  return splitedA[0].localeCompare(splitedB[0]) || parseInt(splitedA[1]) > parseInt(splitedB[1]);
};
